export class User {
    constructor(
        public id?: string,
        public email?: string,
        public firstName?: string,
        public lastName?: string,
        public company?: string,
        public companyName?: string,
        public address?: string,
        public phone?: string,
        public langKey?: string,
        public imageUrl?: string,
        public authorities?: string[],
        public deletedDate?: string,
    ) {}
}
